module.exports = __webpack_public_path__ + "img/pos-o.243765c4.svg";